module.exports = __webpack_public_path__ + "static/media/avatars_all_31.e11e828d.png";